import usePageBuilderSlider from '../functions/pagebuilderSliders';
import {Navigation} from 'swiper';
import useBreakpoints from '../composables/useBreakpoints';
import useFixedTitle from '../composables/useFixedTitle';
import {simpleParallax} from '../functions/parallax';
import {isSafari} from '../functions/browserCheck';

document.addEventListener('DOMContentLoaded', () => {
    initItemPage();

});

let titlePosition = null;

function fixTitleOnText() {
    const fixedTitle = document.querySelector(`[data-toggle="fixed-title"]`);
    if (!fixedTitle) {
        return;
    }

    if (!titlePosition) {
        const target = document.querySelector(`[data-position-target="${fixedTitle.getAttribute('id')}"]`);
        titlePosition = target ? target.getBoundingClientRect().top : null;
    }

    useFixedTitle({
        fixedElement: fixedTitle,
        offset: titlePosition,
        onSuccess: () => window.removeEventListener('scroll', fixTitleOnText),
    });
}

export function initItemPage() {
    const {breakpoints: tailwindBreakpoints} = useBreakpoints();

    usePageBuilderSlider('.pb-slider',
        {
            modules: [Navigation],
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },
        },
        ({options, swiperChildren}) => {
            if (swiperChildren.length > 1) {
                options.loop = true;
            }
        },
    );

    usePageBuilderSlider('.pb-slider-2-items',
        {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },
            breakpoints: {
                [parseInt(tailwindBreakpoints.md)]: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            },
        },
        ({options, swiperChildren}) => {
            if (swiperChildren.length > 2) {
                options.loop = true;
            }
        },
    );

    usePageBuilderSlider('.pb-slider-small',
        {
            modules: [Navigation],
            slidesPerView: 1,
            centeredSlides: true,
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },
        },
        ({options, swiperChildren}) => {
            if (swiperChildren.length > 2) {
                options.loop = true;
            }
        },
    );

    // getHeaderHeight();
    const fixedBanner = document.querySelector('.fixed-banner');

    if (fixedBanner && isSafari()) {
        simpleParallax(fixedBanner);
    }
}

window.addEventListener('scroll', fixTitleOnText);

